import { createSelector } from 'reselect';
import { FeatureTestVariant } from '~/types/FeatureTest';
import { ApplicationState } from '../store';

const getFeatureTestNameByProp = (_: unknown, props: { featureTestName: string }) =>
  props.featureTestName;

const getFeatureVariant = (_: unknown, props: { variantName: string }) => props.variantName;

export const getFeatureTestStore = (state: ApplicationState) => state.featureTests;

export const areFeatureTestsLoading = createSelector(
  getFeatureTestStore,
  (featureTestStore) => featureTestStore.isLoading,
);

export const getFeatureTestVariants = createSelector(
  getFeatureTestStore,
  (featureTestStore) => featureTestStore.testVariants,
);

export const getFeatureTestVariantByName = createSelector(
  getFeatureTestStore,
  getFeatureTestNameByProp,
  (featureTestStore, featureTestName): Maybe<FeatureTestVariant> =>
    featureTestStore.testVariantByFeature[featureTestName] || null,
);

export const userHasFeatureTestVariant = createSelector(
  getFeatureTestVariantByName,
  getFeatureVariant,
  (featureTestVariant, variantName) =>
    featureTestVariant ? featureTestVariant.name === variantName : false,
);
